var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonTickBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8576 16.6573C10.6576 16.6573 10.4676 16.5773 10.3276 16.4373L5.2175 12.6373C4.9275 12.3473 4.9275 11.8673 5.2175 11.5773C5.5075 11.2873 5.9875 11.2873 6.2775 11.5773L10.8576 14.8473L18.0674 8.2175C18.3574 7.9275 18.8374 7.9275 19.1274 8.2175C19.4174 8.5075 19.4174 8.9875 19.1274 9.2775L11.3876 16.4373C11.2476 16.5773 11.0576 16.6573 10.8576 16.6573Z",
    fill: "#292d32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonTickBlack);
export default __webpack_public_path__ + "static/media/button_tick_black.b26943ec8fa3747ec0c2f1a17485c275.svg";
export { ForwardRef as ReactComponent };